import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlinePencilLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M1.7 14.3h12.594M6.947 11.636l-3.149.564.525-3.177 7.064-7.014a1.05 1.05 0 0 1 1.148-.229q.194.08.342.23l1.112 1.107a1.045 1.045 0 0 1 0 1.484z"
    />
  </svg>
);
export default SvgStreamlinePencilLine;
